import { useEffect } from "react";

export const Premanubandh = ({ onClose }) => {
    useEffect(() => {
        // Function to handle keydown event
        const handleKeyDown = (event) => {
            if (event.key === "Escape") {
                onClose(); // Call the onClose function when Esc is pressed
            }
        };

        // Add event listener when the component mounts
        window.addEventListener("keydown", handleKeyDown);

        // Clean up event listener when the component unmounts
        return () => {
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, [onClose]);

    return (
        <>
            <div className="modal" style={{ display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: "rgba(0, 0, 0, 0.5)", position: "fixed", top: 0, left: 0, width: "100%", height: "100%", overflowY: "auto", zIndex: 1050, }}>
                <div className="modal-content" style={{ padding: "20px", background: "#fff", borderRadius: "8px", maxWidth: "500px", width: "95%", boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.3)", maxHeight: "95vh", overflowY: "auto", }}>
                    <div className="img-fluid mb-4">
                        <picture><img src="/media/poemsmar/premanubandh.jpg" alt=" प्रेमानुबंध | Lone Wolf writes " style={{ width: "100%", height: "18rem", objectFit: "cover", borderRadius: "6px", backgroundColor: "gray", }} /></picture>
                    </div>

                    <h2 style={{ textAlign: "center", color: "red" }}>प्रेमानुबंध</h2>
                    <hr />

                    <p style={{ textAlign: "center" }}>
                        जेंव्हा जेंव्हा मी आयुष्यात वळून पाहतो,<br />
                        तेंव्हा तेंव्हा मला फक्त तू दिसतेस;<br />
                        प्रत्येक आठवणीतून, प्रत्येक स्वप्नातून,<br />
                        साद मला तू देत असतेस.<br />
                        <br />
                        तुज्याशिवाय जगणे मला नाही जमणार,<br />
                        पण प्रेम मात्र मी फक्त तुझ्यावरच करणार;<br />
                        यदाकदाचित तू माझ्या जीवनातही नसणार,<br />
                        पण ध्यानी-मनी फक्त तूच असणार.<br />
                        <br />
                        जसे आमवश्येला आकाशातील प्रत्येक तारा,<br />
                        चंद्राविना एकटा आहे;<br />
                        तसेच माझ्या जीवनातील प्रत्येक सुखकर क्षण,<br />
                        तुझ्याविना अपुरा आहे.<br />
                        <br />
                        चालकाला ओढ पावसाची,<br />
                        चंद्राला ओढ चांदण्यांची;<br />
                        आणि मनाला या माझा,<br />
                        ओढ फक्त तुझ्या मिलनाची.<br />
                        <br />
                        प्रेमळ क्षण सहवासाचे तुज्या,<br />
                        विसरू ना शकेन कधी,<br />
                        विश्वास तुझ्याबद्दलचा मनी,<br />
                        विरझू ना शकेन कधी.<br />
                        <br />
                        प्रेमात तुझ्या मी,<br />
                        स्वतःला विसरून गेलो;<br />
                        प्रयत्न केला खूप,<br />
                        पण तुझा मी न झालो.<br />
                        <br />
                        प्रेमाचे ते बीज रोवले,<br />
                        ते ही ना उगवले;<br />
                        प्रेमवृक्ष ना फुलला कधी,<br />
                        मनालाही का ते ना उमजले.<br />
                        <br />
                        तू भेटणार कधीतरी,<br />
                        तू भेटणार कोठेतरी;<br />
                        विचार हाच नेहमी,<br />
                        प्रेम आपुले अधुरे तरी.<br />
                        <br />
                        मला हवी तू, तुला हवा मी;<br />
                        इच्छा मनी हीच नेहमी;<br />
                        नियतीने टाकले फासे असे काही,<br />
                        आणि विस्कटून गेले सर्वकाही.<br />
                        <br />
                        मग,<br />
                        <br />
                        मनावर ना राहतो ताबा,<br />
                        आसवे वाहतात बेधुंद;<br />
                        परी जपावासा वाटतो,<br />
                        आपला प्रेमानुबंध.<br />
                        <br />
                    </p>

                    <div className="modal-footer" style={{ textAlign: "right" }}>
                        <button type="button" onClick={onClose} className="btn btn-secondary" style={{ backgroundColor: "red", border: 0, padding: "10px 20px", color: "#fff", borderRadius: "5px", }}>
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};
